import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import wordmark from '@assets/brand_name.svg';

export interface BrandWordmarkProps {
  /** Rendered height in px (width scales automatically to keep aspect ratio). */
  height?: number;
  /**
   * 'dark'  → original dark-green wordmark, for light backgrounds.
   * 'light' → whitened wordmark (CSS filter), for dark backgrounds.
   */
  variant?: 'dark' | 'light';
  sx?: SxProps<Theme>;
}

/**
 * Vaidvana wordmark (the serif "Vaidvana" lockup with the leaf accent).
 *
 * The source artwork is a single dark-green color, so it's invisible on dark
 * surfaces as-is. The `light` variant whitens it via a CSS filter rather than
 * shipping a second asset — `brightness(0) invert(1)` flattens the artwork to
 * solid white while preserving its alpha edges.
 */
const BrandWordmark: React.FC<BrandWordmarkProps> = ({ height = 28, variant = 'dark', sx }) => (
  <Box
    component="img"
    src={wordmark}
    alt="Vaidvana"
    sx={{
      height,
      width: 'auto',
      display: 'block',
      ...(variant === 'light' ? { filter: 'brightness(0) invert(1)' } : null),
      ...sx,
    }}
  />
);

export default BrandWordmark;
